<ng-container *transloco="let t">
    <div class="blue-background"></div>
    <header
        focusonnavigation=""
        aria-label="Get started"
        id="homepage-header"
        class="home-header-background"
        tabindex="-1"
    >
        <div class="home-header-section">
            <div class="home-header-headline">
                <h1>{{ client?.clientName }}</h1>
                <h2 *ngIf="client?.isEnabled">
                    {{ t("program.header.second") }}
                </h2>
                <h2 *ngIf="!client?.isEnabled">
                    {{ client?.siteDisabledHtml }}
                </h2>
            </div>
        </div>
    </header>
    <div
        *ngIf="client?.isEnabled"
        fxLayoutAlign="center center"
        class="program-box-outer"
    >
        <div class="program-box-inner">
            <app-program-card-collection></app-program-card-collection>
        </div>
    </div>
</ng-container>
